<template>
  <div class="zyz-wrapper" :style="{height:height*0.59+'px',width:width*0.2994+'px'}">
    <div class="zyz-head">热心居民</div>
    <div style="padding:3.48% 1.74%">
      <x-scroll :contentArr="score" :height="height*0.412" :lineNum="3" :width="width*0.096" :time="3000" :chixuTime="3" v-if="score.length">
        <div class="zyz-item" slot="scroll" slot-scope="props" :style="{height:height*0.41+'px',width:width*0.0781+'px',marginLeft:width*0.018+'px'}" >
          <img v-if="props.todo.headPic!=undefined" :src="props.todo.headPic" :style="{height:height*0.344+'px',width:width*0.078+'px'}" >
          <div class="zyz-name">{{props.todo.name}}</div>
        </div>
      </x-scroll>
   </div>
  </div>
</template>
<script>
  import xScroll from '../../../components/xScroll'
  export default {
    components: {
      xScroll
    },
    props:{
      height:null,
      width:null,
      score:null,
    },
    data () {
      return {
        num:[{
          name:'张长春'
        },{
          name:'张长秋'
        },{
        name:'张长冬'
      }]
      }
    }
  }
</script>
<style scoped>
  .zyz-wrapper{
    /*width:575px;*/
    /*height:260px;*/
    background: #fff;
    border:1px solid #fff;
    border-radius: 5px;
    padding-top: 1.44%;
    color:#444;
  }
  .zyz-head{
    height: 20px;
    line-height: 20px;
    border-left: 3px solid #d22b2b;
    padding-left: 10px;
    font-size: 16px;
  }
  .zyz-item{
    /*width: 150px;*/
    display: flex;
    flex-flow: column;
    /*margin-left:35px*/
  }
  .zyz-name{
    text-align: center;
    background: #fff2df;
    flex:1;
    line-height: 30px
  }
</style>

